module.exports = __webpack_public_path__ + "img/Sudan.76e42dd5.png";